import {config} from "../../config";
import SetupApi from "../api/functions/Setup";
import {setAuthorization} from "../api/base";
import {QHelpers} from "./index";

/** Merge latest setup into ACCOUNT so onboarding resume reflects Stripe connect, etc. */
export const refreshAccountSetup = async (): Promise<any | null> => {
    try {
        const token = QHelpers.store.getAccessToken();
        if (token) {
            setAuthorization(token);
        }

        const response: any = await SetupApi.detail();
        const setup = response?.data?.data;
        if (!setup) {
            return null;
        }

        const raw = localStorage.getItem(config.LOCAL_STORE.ACCOUNT);
        const account = raw ? JSON.parse(raw) : {};
        const hasStripe = Boolean(setup.stripe_access_token);
        const isLogged = Boolean(Number(account?.user?.is_logged ?? 0));
        const step = !hasStripe ? 1 : (!isLogged ? 2 : -1);

        const next = {
            ...account,
            user: {
                ...(account.user || {}),
                setup,
                sync_engine_version: setup.sync_engine_version || account.user?.sync_engine_version,
            },
            step,
        };
        localStorage.setItem(config.LOCAL_STORE.ACCOUNT, JSON.stringify(next));
        return next;
    } catch {
        return null;
    }
};
